<template>
  <div v-if="show" class="guesture-msg">
    <div class="guesture-msg__icon"></div>
    <!-- <div class="guesture-msg__text">Swipe to explore & tap to view</div> -->
    <div class="guesture-msg__text">
      Swipe to explore & tap to view<br />
      <span>Connection Successful</span>
      <!-- Successfully logged in <span v-if="authed_with">via {{authed_with}}.</span> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      //authed_with: null,
    };
  },
  mounted() {
    const auth = localStorage.getItem("Authentication");
    if (!auth || JSON.parse(auth).complete == false) return null;

    //this.authed_with = ( auth || JSON.parse(auth).service ) ? JSON.parse(auth).service : null;

    this.show = true;

    document.addEventListener("mousewheel", this.handleGesture, false);
    document.addEventListener("touchstart", this.handleGesture, false);
    document.addEventListener("click", this.handleGesture, false);
  },
  methods: {
    handleGesture() {
      this.show = false;
    },
  },
};
</script>
